import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenQtyMultiState from "@tCentro/Store/Reducer/CenQtyMultiState";
import { Draft } from "immer";

const initialState: CenQtyMultiState = {
    isMultiError: false,
};

const reducer = {
    "Pages/CenQtyMultiState": (
        draft: Draft<CenQtyMultiState>,
        action: {
            isMultiError: boolean;
        },
    ) => {
        draft.isMultiError = action.isMultiError;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
